export function InputErrorSpan({ message }: { message?: string }) {
  return <span className="text-errorColor text-xs">{message}</span>;
}
